import getFlaggedDesctiprionStore from "../../../../../stores/supervisor-store/flagged-description-store";
import Et3Button from "../../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";

const FlaggedDescriptionForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      onClick={() => {
        getFlaggedDesctiprionStore().getFlaggedDescriptions();
      }}
      isEnabled={true}
      size="LARGE"
      text="GET"
      type="GET"
    />
  );
});
export default FlaggedDescriptionForm;
